import React, { memo } from "react";
import styles from "./ConfigCtas.module.scss";
import TyCode from "./ty-code/TyCode";
import Save from "./save/Save";
import QuickLinks from "./quick-links/QuickLinks";
import { useCarConfigLabel } from "../../../../utils/labelUtils";
import { useCarConfigSelector } from "../../../../redux/store";

const ConfigCtas: React.FC = () => {
    const hideSidebar = useCarConfigSelector((state) => state.carConfigSettings.hideSidebar);

    const navigationLabel = useCarConfigLabel("carConfigA11yNavCTA");
    if (hideSidebar) return null;

    return (
        <nav className={styles.nav} aria-label={navigationLabel}>
            <Save />
            <TyCode />
            <QuickLinks />
        </nav>
    );
};

export default memo(ConfigCtas);
